import * as yup from "yup";

const transactionOverrideSchema = yup.object().shape({
  entity_id: yup.string().max(256).required(),
});

export const transactionOverrideAllocationCreateSchema = yup.object().shape({
  allocation_rule_lookups: yup.array().of(transactionOverrideSchema),
  transaction_code_id: yup.string().max(256).required(),
});

export interface transactionOverrideAllocationFormData {
  allocation_rule_lookups: Record<string, string>[];
  transaction_code_id: string;
}
